/* Load Modules */
import {memoize, cloneDeep} from "lodash";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType,
    getNewGeneratedId,
    uuidv4
} from "../../../../../../../utils/utils";

import {LEVELS_NAMES} from "./ProgressivesConfigurationSection.constants";

export const defaultsWays = memoize(
    ({
         schema,
         progressivesConfig,
         type,
         prefix,
         isParent,
         hasPreset,
         rules,
         schemaKey
     }) => {
        let defaults = {};

        defaults["uuid"] = uuidv4();

        if (type === "progressive_group_levels") {
            defaults["id"] = "Prog. Group";
        } else if (type === "progressive_group") {

        } else {
            defaults["id"] = getNewGeneratedId(prefix, progressivesConfig);
        }

        Object.keys(schema.definitions[schemaKey].properties).map(item => {
            if (item !== "id" && item !== "type" && item !== "uuid") {
                if (item !== "preset" || (item == "preset" && hasPreset))
                    defaults[item] =
                        checkRenderForProvider(
                            item,
                            schema.definitions[schemaKey].properties
                        ) && schema.definitions[schemaKey].properties[item]
                            ? (schema.definitions[schemaKey].properties[item]
                                .convert
                                ? schema.definitions[schemaKey].properties[
                                item
                                ].default / 100
                                : schema.definitions[schemaKey].properties[
                                    item
                                    ].default) ||
                            checkDefaultForType(
                                schema.definitions[schemaKey].properties[item]
                                    .type
                            )
                            : null;
            }
        });

        let initialValues = [];
        const prizesSchema =
            schema.definitions[schemaKey].properties.prizes.items.properties;

        if (isParent && type !== 'reelstrike' && type !== 'luckytokenslink') {
            const emptyValues = defaultsPrize({
                schema: prizesSchema,
                index: rules.prizes[0]
            });

            defaults["children"] = [
                defaultsWays({
                    schema: schema,
                    progressivesConfig,
                    type: type === "levels" ? "progressive_group_levels" : "progressive_group",
                    prefix: "prog-group",
                    isParent: false,
                    rules,
                    schemaKey
                })
            ];

            initialValues.push(emptyValues);
        } else if (isParent && type == 'reelstrike') {
            defaults["children"] = [
                defaultsWays({
                    schema: schema,
                    progressivesConfig,
                    type: "progressive_group_reelstrike",
                    prefix: "prog-group",
                    isParent: false,
                    rules,
                    schemaKey
                })
            ];
        } else if (isParent && type == 'luckytokenslink') {
            defaults["children"] = [
                defaultsWays({
                    schema: schema,
                    progressivesConfig,
                    type: "progressive_group",
                    prefix: "prog-group",
                    isParent: false,
                    rules,
                    schemaKey
                })
            ];
        } else {
            const newRules = cloneDeep(rules).prizes;
            if (type != 'progressive_group_reelstrike') newRules.shift();

            for (let i = 0; i < newRules.length; i++) {
                const emptyValues = defaultsPrize({
                    schema: prizesSchema,
                    index: newRules[i]
                });
                initialValues.push(emptyValues);
            }
        }

        if (type === "progressive_group" || type === "progressive_group_levels") {
            defaults["coin"] = [];
        }

        defaults["terminal_groups"] = [];
        defaults["game_groups"] = [];
        defaults["type"] = type;
        defaults["open"] = true;
        defaults["prizes"] = initialValues;

        return defaults;
    }
);

export const defaultsPrize = memoize(({schema, index}) => {
    let defaults = {};

    defaults["prize_index"] = parseInt(index);
    defaults["level_title"] = LEVELS_NAMES[index];
    defaults["uuid"] = uuidv4();
    defaults["open"] = true;

    Object.keys(schema).map(item => {
        if (item !== "id" && item !== "prize_index" && item !== "uuid") {
            if (schema[item].hasOwnProperty("defaults")) {
                defaults[item] = schema[item].convert
                    ? schema[item].defaults[index] / 100
                    : schema[item].defaults[index];
            } else if (schema[item].hasOwnProperty("default")) {
                defaults[item] = schema[item].convert
                    ? schema[item].default / 100
                    : schema[item].default;
            } else {
                defaults[item] =
                    checkRenderForProvider(item, schema) && schema[item]
                        ? schema[item].hasOwnProperty("default")
                            ? schema[item].convert
                                ? schema[item].default / 100
                                : schema[item].default
                            : checkDefaultForType(schema[item].type)
                        : null;
            }
        }
    });

    return defaults;
});
